import { BrowserRouter as Router } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { AuthProvider } from "./contexts/AuthContext";
import AppRoutes from "./routes";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./config/queryClient";
import { Layout } from "./components/layout";
import { AppStorePopupProvider } from "./contexts";
import { CartProvider } from "./contexts/CartContext";
import { AddToCartModalProvider } from "./contexts/AddToCartModalContext";
import { AppStorePopupManager } from "./components/shared/AppStorePopupManager";
import CookieConsentWithAnalytics from "./components/shared/CookieConsentWithAnalytics";
import { Toaster } from "@/components/ui/sonner";
import { AddToCartModal } from "./components/cart/AddToCartModal";
import { CartDrawer } from "./components/cart/CartDrawer";
import { DeviceProvider } from "./contexts/DeviceContext";
import "./index.css";
import { SidebarProvider } from "./contexts/SidebarContext";

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || "";

const App = () => {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <Toaster position="top-center" richColors />
        <QueryClientProvider client={queryClient}>
          <DeviceProvider> 
          <CartProvider>
            <AddToCartModalProvider>
              <SidebarProvider>
              <AppStorePopupProvider>
                <Router
                  future={{
                    v7_startTransition: true,
                  }}
                >
                  <Layout>
                    <AppRoutes />
                  </Layout>
                  <AppStorePopupManager />
                  <CookieConsentWithAnalytics />
                  <AddToCartModal />
                  <CartDrawer />
                </Router>
              </AppStorePopupProvider>
              </SidebarProvider>
            </AddToCartModalProvider>
          </CartProvider>
          </DeviceProvider>
        </QueryClientProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
};

export default App;
